<!-- both products available -->
<div
    class="block--content block"
    *ngIf="(fixedSumProducts$ | async).length > 0 && (variableSumProduct$ | async)"
    style="margin: 0 0 20px 0; height: auto; min-height: 0px">
    <div class="block--wrap block">
        <div class="money-loading-module-area" ridangoMatchHeight="block-full-width">
            <div class="block-half-width">
                <ridango-block-full-width>
                    <h2 class="block-full-width__title choose-amount">
                        {{ 'CHOOSE_AMOUNT' | translate }}
                    </h2>

                    <ridango-block-items-three>
                        <ridango-selectable-checkable-item
                            #radioItem
                            *ngFor="let p of fixedSumProducts$ | async"
                            [locale]="locale"
                            [item]="p"
                            [selected]="(selectedProduct$ | async)?.product_id === p.product_id"
                            [useShortName]="true"
                            [tabIndex]="getTabIndex(p)"
                            (onItemSelected)="setSelectedProduct($event)"
                            (onMovedLeft)="selectLeftProduct($event)"
                            (onMovedRight)="selectRightProduct($event)"
                            (onFocused)="focus($event)"
                            (onBlurred)="blur($event)"></ridango-selectable-checkable-item>
                    </ridango-block-items-three>
                </ridango-block-full-width>
            </div>

            <div class="block-circle-width-height" style="min-height: 192px">
                <ridango-vertical-or-separator></ridango-vertical-or-separator>
            </div>

            <div class="block-half-width">
                <ridango-block-full-width>
                    <h2 class="block-full-width__title">
                        {{ 'CUSTOM_AMOUNT' | translate }}
                    </h2>
                    <p class="block-full-width__description">
                        <span>{{ 'RANGE_AMOUNT' | translate }}</span>
                        <span
                            >{{ getVariableSumMin(variableSumProduct$ | async) }} -
                            {{ getVariableSumMax(variableSumProduct$ | async) }}</span
                        >
                        <span> {{ appStartupService.getCurrency() | translate }}</span>
                    </p>

                    <div class="card-details-area">
                        <div class="card-details-area__card-money">
                            <ridango-form-field>
                                <input
                                    [formControl]="amountField"
                                    (blur)="setSum(amountField.value)"
                                    (keydown.enter)="setSum(amountField.value, true)"
                                    ridangoInput
                                    type="text"
                                    name="amount" />

                                <ridango-label>
                                    {{ 'PH_WALLET_LOADING_ENTER_AMOUNT' | translate }}
                                </ridango-label>
                                <ridango-error *ngIf="!sumValid && amountField.hasError('required')">
                                    {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                                </ridango-error>
                                <ridango-error
                                    *ngIf="
                                        amountField.errors?.pattern &&
                                        !amountField.errors?.min &&
                                        !amountField.errors?.max
                                    ">
                                    {{ 'FIELD_VALIDATION_WALLET_AMOUNT_INVALID_FORMAT' | translate }}
                                </ridango-error>
                                <ridango-error *ngIf="amountField.errors?.min">
                                    {{ 'FIELD_VALIDATION_WALLET_AMOUNT_MIN_VALUE' | translate }}
                                </ridango-error>
                                <ridango-error *ngIf="amountField.errors?.max">
                                    {{ 'LOCAL_VALIDATION_WALLET_AMOUNT_MAX_VALUE' | translate }}
                                </ridango-error>
                            </ridango-form-field>
                        </div>
                    </div>
                </ridango-block-full-width>
            </div>
        </div>

        <div class="money-loading-tab-module-area">
            <div class="v2-tab-panel">
                <div class="v2-tab-panel__position" role="tablist">
                    <div
                        class="v2-tab-panel__tab"
                        id="choose-amount-button"
                        [ngClass]="{ 'v2-tab-panel__tab--active': activeTab === 1 }"
                        (click)="clickTab(1)"
                        (keydown)="keydownFromTab($event, 1)"
                        tabindex="{{ activeTab === 1 ? 0 : -1 }}"
                        role="tab"
                        attr.aria-selected="{{ activeTab === 1 }}"
                        attr.aria-controls="choose-amount-tab">
                        {{ 'CHOOSE_AMOUNT' | translate }}
                    </div>

                    <div
                        class="v2-tab-panel__tab last"
                        id="custom-amount-button"
                        [ngClass]="{ 'v2-tab-panel__tab--active': activeTab === 2 }"
                        (click)="clickTab(2)"
                        (keydown)="keydownFromTab($event, 2)"
                        tabindex="{{ activeTab === 2 ? 0 : -1 }}"
                        role="tab"
                        attr.aria-selected="{{ activeTab === 2 }}"
                        attr.aria-controls="custom-amount-tab">
                        {{ 'CUSTOM_AMOUNT' | translate }}
                    </div>
                </div>

                <div class="v2-tab-panel__content">
                    <ridango-block-full-width>
                        <div
                            id="choose-amount-tab"
                            *ngIf="activeTab === 1"
                            role="tabpanel"
                            tabindex=""
                            attr.aria-labelledby="choose-amount-button">
                            <h2 class="block-full-width__title">
                                {{ 'CHOOSE_AMOUNT' | translate }}
                            </h2>

                            <ridango-block-items-three>
                                <ridango-selectable-checkable-item
                                    #radioItemMobile
                                    *ngFor="let p of fixedSumProducts$ | async"
                                    [locale]="locale"
                                    [item]="p"
                                    [selected]="(selectedProduct$ | async)?.product_id === p.product_id"
                                    [useShortName]="true"
                                    [tabIndex]="getTabIndex(p, true)"
                                    (onItemSelected)="setSelectedProduct($event)"
                                    (onMovedLeft)="selectLeftProduct($event)"
                                    (onMovedRight)="selectRightProduct($event)"
                                    (onFocused)="focus($event)"
                                    (onBlurred)="blur($event)">
                                </ridango-selectable-checkable-item>
                            </ridango-block-items-three>
                        </div>

                        <div
                            id="custom-amount-tab"
                            *ngIf="activeTab === 2"
                            role="tabpanel"
                            attr.aria-labelledby="custom-amount-button">
                            <h2 class="block-full-width__title">
                                {{ 'CUSTOM_AMOUNT' | translate }}
                            </h2>
                            <p class="block-full-width__description">
                                <span>{{ 'RANGE_AMOUNT' | translate }}</span>
                                <span>
                                    {{ getVariableSumMin(variableSumProduct$ | async)
                                    }}{{ appStartupService.getCurrency() | translate }} -
                                    {{ getVariableSumMax(variableSumProduct$ | async)
                                    }}{{ appStartupService.getCurrency() | translate }}</span
                                >
                            </p>
                            <div class="card-details-area">
                                <div class="card-details-area__card-money">
                                    <ridango-form-field>
                                        <input
                                            [formControl]="amountField"
                                            (blur)="setSum(amountField.value)"
                                            ridangoInput
                                            type="text"
                                            name="amount" />

                                        <ridango-label>
                                            {{ 'PH_WALLET_LOADING_ENTER_AMOUNT' | translate }}
                                        </ridango-label>
                                        <ridango-error *ngIf="!sumValid && amountField.hasError('required')">
                                            {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                                        </ridango-error>
                                        <ridango-error *ngIf="amountField.errors?.pattern">
                                            {{ 'FIELD_VALIDATION_WALLET_AMOUNT_INVALID_FORMAT' | translate }}
                                        </ridango-error>
                                        <ridango-error *ngIf="amountField.errors?.min">
                                            {{ 'FIELD_VALIDATION_WALLET_AMOUNT_MIN_VALUE' | translate }}
                                        </ridango-error>
                                        <ridango-error *ngIf="amountField.errors?.max">
                                            {{ 'LOCAL_VALIDATION_WALLET_AMOUNT_MAX_VALUE' | translate }}
                                        </ridango-error>
                                    </ridango-form-field>
                                </div>
                            </div>
                        </div>
                    </ridango-block-full-width>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- only variable sum product present -->
<ridango-block-full-width *ngIf="(fixedSumProducts$ | async).length === 0 && (variableSumProduct$ | async)">
    <h2 class="block-full-width__title">
        {{ 'CUSTOM_AMOUNT' | translate }}
    </h2>
    <p class="block-full-width__description">
        <span>{{ 'RANGE_AMOUNT' | translate }}</span>
        <span
            >{{ getVariableSumMin(variableSumProduct$ | async) }} -
            {{ getVariableSumMax(variableSumProduct$ | async) }}</span
        >
    </p>
    <div class="card-details-area">
        <div class="card-details-area__card-money">
            <ridango-form-field>
                <input
                    [formControl]="amountField"
                    (blur)="setSum(amountField.value)"
                    (keydown.enter)="setSum(amountField.value, true)"
                    ridangoInput
                    type="text"
                    name="amount" />

                <ridango-label>
                    {{ 'PH_WALLET_LOADING_ENTER_AMOUNT' | translate }}
                </ridango-label>
                <ridango-error *ngIf="!sumValid && amountField.hasError('required')">
                    {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                </ridango-error>
                <ridango-error
                    *ngIf="amountField.errors?.pattern && !amountField.errors?.min && !amountField.errors?.max">
                    {{ 'FIELD_VALIDATION_WALLET_AMOUNT_INVALID_FORMAT' | translate }}
                </ridango-error>
                <ridango-error *ngIf="amountField.errors?.min">
                    {{ 'FIELD_VALIDATION_WALLET_AMOUNT_MIN_VALUE' | translate }}
                </ridango-error>
                <ridango-error *ngIf="amountField.errors?.max">
                    {{ 'LOCAL_VALIDATION_WALLET_AMOUNT_MAX_VALUE' | translate }}
                </ridango-error>
            </ridango-form-field>
        </div>
    </div>
</ridango-block-full-width>

<!-- only fixed sum products present -->
<ridango-block-full-width *ngIf="(fixedSumProducts$ | async).length > 0 && !(variableSumProduct$ | async)">
    <h2 class="block-full-width__title choose-amount">
        {{ 'CHOOSE_AMOUNT' | translate }}
    </h2>

    <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3">
        <div *ngFor="let p of fixedSumProducts$ | async">
            <button
                class="btn--big-selection"
                [ngClass]="{ selected: (selectedProduct$ | async)?.product_id === p.product_id }"
                (click)="setSelectedProduct(p)">
                <div class="circle-icon">
                    <span class="icon icon-progress-check hidden"></span>
                </div>
                <div class="btn--big-selection__top-wrapper small-version">
                    <div class="btn--big-selection__top">
                        {{ p | translateObjectField: 'short_name' : locale }}
                    </div>
                </div>
            </button>
        </div>
    </div>
</ridango-block-full-width>
